import FlashMessage from '@totallymoney/ui/components/FlashMessage'

import { flashMessages } from '@config/flashMessages'

import useAppQueryState from '@hooks/useAppQueryState'

const GlobalFlashMessage = () => {
    const { appQueryState } = useAppQueryState()

    if (!appQueryState.flashMessage) return null

    const flashMessage = flashMessages[appQueryState.flashMessage]

    if (!flashMessage) return null

    return (
        <FlashMessage variant={flashMessage.variation}>
            {flashMessage.title}
        </FlashMessage>
    )
}

export default GlobalFlashMessage
